import { storeCreator } from '@/utils/store/store.utils';

interface State {
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
}

const useStore = storeCreator<State>((set) => ({
  isVisible: false,
  setIsVisible: (value) => set(() => ({ isVisible: value })),
}));

export default useStore;
